module.exports = __webpack_public_path__ + "static/media/the-daily-edition-section-header-logo.3ed95ced.png";